import styled from 'styled-components';

export const InfoContainer = styled.section`
  padding: 0 25px;
  margin-bottom: 10px;
  
  @media(min-width: 768px) {
    margin-bottom: 40px;
    padding: 0;
  }
  
  @media(min-width: 1024px) {
    padding: 0;
  }
`;

export const InfoHeading = styled.h1`
  margin: 0;
  padding: 0;
  
  font-size: 18px;
  line-height: 1;
  
  @media(min-width: 768px) {
    font-size: 36px;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  
  @media(min-width: 768px) {
    margin-bottom: 5px;
  }
`;

export const InfoType = styled.span`
  margin-right: 10px;
  padding: 5px 10px;
  
  font-weight: 700;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  color: ${({ theme }) => theme.white};
  
  border-radius: 50px;
  
  background-color: ${({ theme, type }) => {
    switch (type) {
      case "Festive":
        return theme.red;
      case "Tranquil":
        return theme.green;
      case "Family":
        return theme.blue;
      default:
        return theme.blue;
    }
  }};
`;

export const InfoLocation = styled.span`
  display: flex;
  align-items: center;
  
  font-size: 12px;
  line-height: 1;
  
  svg {
    transform: scale(0.6);
    
    fill: ${({ theme }) => theme.blue};
  }
  
  @media(min-width: 768px) {
    font-size: 14px;
    
    svg {
      transform: scale(0.8);
      margin-right: 10px;
    }
  }
`;
